export default __webpack_public_path__ + "static/media/mobile-photo-5.d4e20143.jpg";